export class PosUiState {
  constructor(private posReasons) {}

  dialogCallback = '';
  multiLine = false;
  selected = [];
  dialog = {
    inputValue: '',
    show: false,
    showReasons: false,
    reason: '',
  };

  selectedLine = 0;

  // TODO add unit test
  resetDialog = () => {
    this.multiLine = false;

    this.dialog.show = false;
    this.dialog.showReasons = false;
    this.dialogCallback = '';

    if (this.posReasons.discount && this.posReasons.discount.length > 0) {
      this.dialog.reason = this.posReasons.discount[0];
    } else {
      this.dialog.reason = '';
    }
  };
}

/*
 * Service posUiState. Helper service to break down old <pos> component.
 */
angular.module('posApp').factory('posUiState', (posReasons) => {
  return new PosUiState(posReasons);
});
